import { Button, Grid, GridColumn, Notice, Separator } from 'telia-front-react';
import { observer } from 'mobx-react';
import React from 'react';
import useStores from '../stores/UseStores';

const BiometryNotice = (props: { message: string }): JSX.Element => {
  const {
    translateStore: { translate },
  } = useStores();
  return (
    <>
      <Separator color="invisible" spacing="xxsmall" />
      <Notice>
        <Grid align={['between-xs', 'middle-xs']} noWrap={['sm']}>
          <GridColumn width={['xs', 'max-sm']}>
            <p>{translate(props.message)}</p>
          </GridColumn>
          <GridColumn width={['xs', 'min-sm']}>
            <Button
              text={translate('biometry.readMore')}
              target="_blank"
              url="https://www.telia.ee/abi/teema/857/teenused/sisselogimine"
              variant="secondary"
              iconRight="#arrow-right"
            />
          </GridColumn>
        </Grid>
      </Notice>
    </>
  );
};

export default observer(BiometryNotice);
